import { EnumCommodity, EnumTipoPeaje } from '../../api'
import { LeadModel } from '../../api/Argentia/endpoints/leads/model/leads'
import { ProductSummaryModel } from '../../api/Argentia/endpoints/products/model/products'
import { EnumTipoLead } from '../../api/oData/enums/enumTipoLead'

export interface LeadRequestModel extends Omit<LeadModel, 'id'> {
  id?: number
}

export type LeadInfoCardModel = {
  code: string
  description: string
  product: ProductSummaryModel
  tollType: EnumTipoPeaje
  commodity: EnumCommodity
  leadType: EnumTipoLead
}

export enum EnumLeadFileTabs {
  GENERAL,
  CONTRACTS
}

export enum EnumLeadAnnouncementTypes {
  GENERIC_EMPTY = 0,
  HAS_DRAFT_QUOTE = 1,
  HAS_NOT_CURRENT_QUOTES = 2,
  HAS_REJECTED_QUOTES = 3
}

export enum LeadsSearchMode {
  None = 'None',
  Filtered = 'Filtered',
  Latest = 'Latest',
  AnnouncementList = 'AnnouncementList'
}

export enum EvaluateLeadButtonOptions {
  EVALUATE_LEAD = 1,
  EVALUATE_WITHIN_DATE = 2
}

export type EvaluateLeadModel = LeadModel & {
  startDate?: Date | string | null
  endDate?: Date | string | null
}
